import { render, staticRenderFns } from "./DamageCodes.vue?vue&type=template&id=29833f38"
import script from "./DamageCodes.vue?vue&type=script&lang=ts"
export * from "./DamageCodes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports